import { ProductsCarousel } from './products-carousel';

document.addEventListener('DOMContentLoaded', async () => {
  function hideTab() {
    const tab = document.querySelector('.tabbed-carousels--tab[data-controls="recently-viewed"]');

    if (!tab) return;

    tab.classList.add('hidden');

    // If this tab is currently selected, switch to the next tab
    if (tab.classList.contains('active')) {
      tab.classList.remove('active');
      const nextTab = tab.nextElementSibling;
      if (nextTab) {
        nextTab.classList.add('active');
      }
    }
  }

  function hideContent() {
    const contentPanel = document.querySelector('.tabbed-carousels--content-panel#recently-viewed');

    if (!contentPanel) return;

    contentPanel.classList.add('hidden');

    // If this tab is currently selected, switch to the next tab
    if (contentPanel.classList.contains('active')) {
      contentPanel.classList.remove('active');
      const nextContentPanel = contentPanel.nextElementSibling;
      if (nextContentPanel) {
        nextContentPanel.classList.add('active');
      }
    }
  }

  function insertSlides(productHtmls: string[]) {
    const slidesWrapper = document.querySelector('.recently-viewed--inner-wrapper .swiper-wrapper');

    if (!slidesWrapper) return;

    slidesWrapper.innerHTML = productHtmls
      .map((html) => `<div class="swiper-slide">${html}</div>`)
      .join('');
  }

  const recentlyViewedProducts = window.localStorage.getItem('recently-viewed-products');

  if (!recentlyViewedProducts) {
    hideTab();
    hideContent();
    return;
  }

  const carouselRoot = document.querySelector('.recently-viewed--inner-wrapper');

  if (!carouselRoot) return;

  const displayLimit = parseInt(carouselRoot.getAttribute('data-display-limit') ?? '5');

  // Get the markup for each product handle and append it to the recently-viewed-products section
  const productHandles: string[] = JSON.parse(recentlyViewedProducts!);

  const sampledProductHandles = productHandles.slice(0, displayLimit);

  const promises = await Promise.allSettled(
    sampledProductHandles.map(
      async (handle) =>
        await fetch(`/products/${handle}?view=card&section_id=homepage-component-product-card`)
          .then((r) => r.text())
          .then((htmlString) => {
            const domParser = new DOMParser();
            const doc = domParser.parseFromString(htmlString, 'text/html');
            return doc.querySelector('.shopify-section')?.innerHTML?.trim();
          }),
    ),
  );

  const productHtmls = promises.filter((p) => p.status === 'fulfilled').map((p) => p.value);

  insertSlides(productHtmls.filter((html) => !!html) as string[]);

  (carouselRoot as ProductsCarousel).hydrate();
});
